export function canDownloadThesis(user) {
  return user.permissions.CAN_DOWNLOAD_THESIS;
}

export function canViewThesis(user) {
  return user.permissions.CAN_VIEW_THESIS;
}

export function canCreateDiagnosis(user) {
  return user.permissions.CAN_CREATE_DIAGNOSIS;
}

export function canViewDiagnosis(user) {
  return user.permissions.CAN_VIEW_DIAGNOSIS;
}

export function canViewPetitionModel(user) {
  return user.permissions.CAN_VIEW_PETITION_MODEL;
}

export function canViewNewsArticle(user) {
  return user.permissions.CAN_VIEW_NEWS_ARTICLES;
}

export function userIsAdmin(user) {
  return user.permissions.IS_ADMIN;
}

export function canViewNotification(user) {
  return user.permissions.CAN_VIEW_NOTIFICATIONS;
}

export function canCreateReusableDiagnosisLink(user) {
  return user.permissions.CAN_CREATE_REUSABLE_DIAGNOSIS_LINK;
}
